import { Box, Container, Stack, Typography } from '@mui/material';
import { Logo } from 'src/components/logo';
import { brandConfig } from 'src/config/brand';
import { RouterLink } from 'src/components/router-link';
import { paths } from 'src/paths';
import { BusinessFooter } from 'src/components/business-footer';

export const Footer = ({ showBusinessInfo = false, ...props }) => (
  <Box
    sx={{
      borderTopColor: 'divider',
      borderTopStyle: 'solid',
      borderTopWidth: 1,
      py: 4,
    }}
    {...props}
  >
    <Container maxWidth="lg">
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        alignItems="center"
        spacing={2}
      >
        <Stack
          alignItems="center"
          component={RouterLink}
          direction="row"
          display="inline-flex"
          href={paths.index}
          spacing={1}
          sx={{ textDecoration: 'none' }}
        >
          <Box sx={{ display: 'inline-flex', height: 24, width: 24 }}>
            <Logo />
          </Box>
          <Typography
            sx={{
              color: 'text.primary',
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: 14,
              fontWeight: 800,
            }}
          >
            {brandConfig.name}
          </Typography>
        </Stack>
        <Typography
          color="text.secondary"
          variant="caption"
        >
          {brandConfig.copyright}
        </Typography>
        <Stack
          direction="row"
          spacing={2}
        >
          <Typography
            color="text.secondary"
            component={RouterLink}
            href={paths.privacy}
            sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            variant="caption"
          >
            개인정보처리방침
          </Typography>
          <Typography
            color="text.secondary"
            component={RouterLink}
            href={paths.terms}
            sx={{ textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
            variant="caption"
          >
            서비스 이용약관
          </Typography>
        </Stack>
      </Stack>
      {showBusinessInfo && (
        <Box sx={{ mt: 2 }}>
          <BusinessFooter />
        </Box>
      )}
    </Container>
  </Box>
);
